module.exports = __webpack_public_path__ + "img/title@2x.ab75190f.png";